(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slh-candle-parties"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const root=document.getElementById('slh-party');
  if(!root)return;
  const $ = id => root.querySelector('#'+id);
  const rate = 60;
  const deliveryNames = {pickup:'Local pickup',host:'Ship to the host',individual:'Ship to each guest'};
  const timeSlots = {'18':'6:00–7:00 p.m.','19':'7:00–8:00 p.m.','20':'8:00–9:00 p.m.','21':'9:00–10:00 p.m.'};
  const state = {guests:6,scent:'Lavender Vanilla',delivery:'pickup',date:'',time:''};
  const money = n => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(n);
  const chicagoToday = () => {
    const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'America/Chicago',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const p = t => parts.find(x=>x.type===t).value;
    return `${p('year')}-${p('month')}-${p('day')}`;
  };
  const shiftDate = (date, days) => {const d=new Date(`${date}T12:00:00Z`);d.setUTCDate(d.getUTCDate()+days);return d.toISOString().slice(0,10);};
  const firstAllowed = () => shiftDate(chicagoToday(),14);
  const dateLabel = (date, short=false) => new Intl.DateTimeFormat('en-US',{timeZone:'UTC',weekday:short?'short':'long',month:'short',day:'numeric',...(short?{}:{year:'numeric'})}).format(new Date(`${date}T12:00:00Z`));
  const dateProblem = date => {
    if(!date) return '';
    if(!/^\d{4}-\d{2}-\d{2}$/.test(date)||!Number.isFinite(Date.parse(`${date}T12:00:00Z`))) return 'Choose a valid preferred date.';
    if(date<firstAllowed()) return 'Please choose a date at least 14 days from today.';
    if(![0,5,6].includes(new Date(`${date}T12:00:00Z`).getUTCDay())) return 'Please choose a Friday, Saturday, or Sunday.';
    return '';
  };
  function update() {
    $('guest-count').value=state.guests;
    $('guest-range').value=state.guests;
    $('decrease').disabled=state.guests<=4;
    $('increase').disabled=state.guests>=16;
    $('summary-guests').textContent=`${state.guests} guests`;
    $('summary-scent').textContent=state.scent;
    $('summary-delivery').textContent=deliveryNames[state.delivery];
    $('summary-total').textContent=money(state.guests*rate);
    $('book-party').hidden=state.delivery==='individual';
    $('booking-help').textContent=state.delivery==='individual'?'Separate guest deliveries need a shipping quote. Prepare an inquiry below before booking.':'Choose the same guest count in the booking calendar. Checkout confirms the final total.';
    const validDate=state.date&&!dateProblem(state.date);
    $('summary-date').textContent=validDate?dateLabel(state.date,true):'Choose an evening';
    $('summary-time').textContent=timeSlots[state.time]?`${timeSlots[state.time]} CT`:'Choose a one-hour class';
    $('summary-extra').textContent=state.delivery==='pickup'?'Before applicable tax. No shipping charge for pickup.':'Before shipping and applicable tax. Shipping is quoted separately; it is not included above.';
    $('delivery-help').textContent=state.delivery==='pickup'?'Pickup location and timing are arranged with Shonté before your party.':state.delivery==='host'?'All kits ship to one address within 2 business days after ordering. Delivery time is additional. Shipping is quoted separately.':'Separate guest deliveries need a shipping quote before booking. Prepare an inquiry with the guest locations; Shonté will confirm the shipping arrangements.';
    $('inquiry-plan').textContent=`${state.guests} guests · ${state.scent} · ${deliveryNames[state.delivery]}${validDate?` · ${dateLabel(state.date,true)}`:''}${timeSlots[state.time]?` · ${timeSlots[state.time]} CT`:''} · ${money(state.guests*rate)} before ${state.delivery==='pickup'?'applicable tax':'shipping and tax'}`;
    root.querySelectorAll('[data-scent]').forEach(button=>{
      const active=button.dataset.scent===state.scent;
      button.classList.toggle('selected',active);button.setAttribute('aria-pressed',String(active));button.querySelector('b').textContent=active?'✓':'+';
    });
    root.querySelectorAll('[data-date]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.date===state.date)));
  }
  function setGuests(value) {
    const n=Number(value);
    state.guests=Math.max(4,Math.min(16,Number.isFinite(n)?Math.round(n):4));update();
  }
  $('decrease').addEventListener('click',()=>setGuests(state.guests-1));
  $('increase').addEventListener('click',()=>setGuests(state.guests+1));
  $('guest-count').addEventListener('input',event=>{if(event.target.value!==''&&event.target.validity.valid)setGuests(event.target.value);});
  $('guest-count').addEventListener('change',event=>setGuests(event.target.value));
  $('guest-range').addEventListener('input',event=>setGuests(event.target.value));
  root.querySelectorAll('[name="delivery"]').forEach(input=>input.addEventListener('change',()=>{state.delivery=input.value;update();}));
  root.querySelectorAll('[data-scent]').forEach(button=>button.addEventListener('click',()=>{
    state.scent=button.dataset.scent;
    $('scent-feedback').textContent=`${state.scent} is selected for your party plan.${state.scent==='Seasonal scents'?' Tell Shonté your seasonal preferences in the inquiry; availability is confirmed separately.':' You can include mixed guest preferences in your inquiry.'}`;update();
  }));
  function validateDate() {
    $('party-date').min=firstAllowed();
    state.date=$('party-date').value;
    const issue=dateProblem(state.date);
    $('party-date').setCustomValidity(issue);
    $('party-date').setAttribute('aria-invalid',String(Boolean(issue)));
    $('date-error').textContent=issue;update();return !issue;
  }
  $('party-date').min=firstAllowed();
  let candidate=firstAllowed();
  for(let i=0,count=0;i<14&&count<4;i++,candidate=shiftDate(candidate,1)) {
    if(![0,5,6].includes(new Date(`${candidate}T12:00:00Z`).getUTCDay()))continue;
    const button=document.createElement('button');button.type='button';button.dataset.date=candidate;button.textContent=dateLabel(candidate,true);button.setAttribute('aria-pressed','false');
    button.addEventListener('click',()=>{$('party-date').value=button.dataset.date;validateDate();});$('date-suggestions').append(button);count++;
  }
  $('party-date').addEventListener('input',validateDate);
  $('party-date').addEventListener('change',validateDate);
  function validateTime() {
    state.time=$('party-time').value;
    const issue=Object.hasOwn(timeSlots,state.time)?'':'Please choose a one-hour class between 6 and 10 p.m. Central.';
    $('party-time').setCustomValidity(issue);
    $('party-time').setAttribute('aria-invalid',String(Boolean(issue)));
    $('time-error').textContent=issue;
    update();return !issue;
  }
  $('party-time').addEventListener('change',validateTime);
  const tabs=Array.from(root.querySelectorAll('[role="tab"]'));
  function selectTab(tab,focus=false){tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;$(item.getAttribute('aria-controls')).hidden=!selected;});if(focus)tab.focus();}
  tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>selectTab(tab));tab.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const j=event.key==='Home'?0:event.key==='End'?tabs.length-1:(i+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length;selectTab(tabs[j],true);}});});
  $('use-plan').addEventListener('click',()=>{update();$('inquiry-error').textContent='';});
  $('inquiry-form').addEventListener('submit',event=>{
    event.preventDefault();
    $('inquiry-error').textContent='';
    const dateValid=validateDate();
    if(!state.date||!dateValid){$('inquiry-error').textContent='Choose a valid preferred party date in the planner above before preparing your inquiry.';$('party-date').scrollIntoView({behavior:'smooth',block:'center'});$('party-date').focus({preventScroll:true});return;}
    if(!validateTime()){$('inquiry-error').textContent='Choose a one-hour class time in the planner above before preparing your inquiry.';$('party-time').scrollIntoView({behavior:'smooth',block:'center'});$('party-time').focus({preventScroll:true});return;}
    const name=$('host-name').value.trim(),email=$('host-email').value.trim();
    if(!name){$('inquiry-error').textContent='Please enter your name.';$('host-name').focus();return;}
    const notes=$('party-notes').value.trim();
    $('inquiry-draft').value=`Hello Shonté,\n\nI’d love to plan a Sarah Lane Home virtual candle pouring party.\n\nHost: ${name}\nEmail: ${email}\nOccasion: ${$('occasion').value}\nPreferred date: ${dateLabel(state.date)}\nPreferred class time: ${timeSlots[state.time]} Central\nGuests: ${state.guests}\nKit: One 8 oz candle kit + one-hour live Zoom class per guest\nFragrance preference: ${state.scent}\nKit arrangement: ${deliveryNames[state.delivery]}\nParty subtotal: ${money(state.guests*rate)} (${state.guests} × $60), before ${state.delivery==='pickup'?'applicable tax':'shipping and applicable tax'}\n${notes?`\nAdditional details: ${notes}\n`:''}\nPlease confirm availability, ${state.delivery==='pickup'?'pickup arrangements':'shipping costs and arrangements'}, preparation instructions, and the final total. I understand this inquiry does not reserve a date.\n\nThank you!\n${name}`;
    $('copy-status').textContent='Copy first, then open the contact form to send it yourself.';
    $('copy-inquiry').firstChild.textContent='COPY INQUIRY ';
    $('inquiry-dialog').showModal();
  });
  $('copy-inquiry').addEventListener('click',async()=>{
    try{await navigator.clipboard.writeText($('inquiry-draft').value);$('copy-status').textContent='Copied. Open the contact form, paste your inquiry, and send it when you’re ready.';$('copy-inquiry').firstChild.textContent='COPIED ';}
    catch{$('inquiry-draft').focus();$('inquiry-draft').select();$('copy-status').textContent='Select and copy the message above, then paste it into the contact form.';}
  });
  root.querySelector('.dialog-close').addEventListener('click',()=>$('inquiry-dialog').close());
  $('inquiry-dialog').addEventListener('click',event=>{if(event.target===$('inquiry-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}});
  update();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slh-cart-pairings"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{if(typeof subscribe!=='function')return;let request=0;subscribe('cart-update',async()=>{const root=document.querySelector('[data-slh-cart-pairings-section]');if(!root)return;const current=++request;try{const url=new URL(window.Shopify.routes.root+'cart',location.origin);url.searchParams.set('section_id',root.dataset.section);const response=await fetch(url);if(!response.ok||current!==request)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html');const replacement=doc.querySelector('[data-slh-cart-pairings-section]');if(replacement&&current===request)root.replaceWith(replacement)}catch{}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slh-exact-header"]) return;
  try {
    
document.addEventListener("click",event=>{const b=event.target.closest(".slh-exact .menu-toggle");if(!b)return;const nav=b.closest(".head").querySelector("nav");b.setAttribute("aria-expanded",nav.classList.toggle("open"))});

  } catch(e) { console.error(e); }
})();
})();
